import style from "./style.scss";

const YouTube = ({ id, time = 0 }) => (
  <div class={style.youtube}>
    <iframe
      src={`https://www.youtube.com/embed/${id}?enablejsapi=1&amp;rel=0&amp;modestbranding=1&amp;playsinline=1&amp;controls=1&amp;fs=1&amp;autoplay=0&amp;start=${time}`}
      loading="lazy"
      allow="fullscreen"
      allowfullscreen="true"
    />
  </div>
);
export default YouTube;
